import constant from '../../constant'

const initialState = { 
  faceIcon: '',
  nickName: '',
  usedDay: 0,
  actType: 0,
  sUserId: '',
  guid: '',
  ch: null,
};

export function userInfo (state = initialState, action) {
  switch (action.type) {
    case constant.USERINFO.GET:
      return {
        ...state,
        ...action.userInfo
      }
    default:
      return state
  }
}